import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const HERO_IMG = '/images/restaurant/04-storefront.jpg';

const BoissonsPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDrinks = async () => {
      try {
        const res = await api.get('/menu/drinks');
        setCategories(res.data);
      } catch (error) {
        console.error('Error fetching drinks:', error);
      } finally { setLoading(false); }
    };
    fetchDrinks();
  }, []);

  return (
    <div className="bg-[#fafaf9]">
      <section className="relative w-full h-[50vh] flex items-center justify-center overflow-hidden" data-testid="drinks-hero">
        <img src={HERO_IMG} alt="Boissons" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center mt-12">
          <span className="text-stone-300 text-[10px] tracking-[0.4em] uppercase block mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>La Taverne</span>
          <h1 className="text-white text-5xl md:text-7xl font-light tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Boissons
          </h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto py-16 px-4 md:px-8">
        {loading ? (
          <div className="text-center py-20 text-stone-400">Chargement...</div>
        ) : (
          categories.map((cat, catIdx) => (
            <div key={cat.id} className="mb-16" data-testid={`drinks-category-${catIdx}`}>
              <h2 className="text-3xl font-light text-center mb-10 pb-4 border-b border-stone-200 text-stone-900" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {cat.name}
              </h2>
              <div className="space-y-4">
                {cat.items.map((item) => (
                  <div key={item.id} className="flex justify-between items-baseline py-2 border-b border-stone-100" data-testid={`drink-item-${item.id}`}>
                    <span className="text-stone-800 text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{item.name}</span>
                    <span className="text-red-900 font-medium text-base" style={{ fontFamily: "'Outfit', sans-serif" }}>{parseFloat(item.price).toFixed(2)}&euro;</span>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </section>
    </div>
  );
};

export default BoissonsPage;
